import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthorizeService } from '../services/authorize.service';
import { currentTimezoneDateTime, isNotEmpty } from 'src/app/extensions/utilities';

@Injectable({
  providedIn: 'root',
})
export class HeadersInterceptor implements HttpInterceptor {
  constructor(private _authorizeService: AuthorizeService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const ianaTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let headers = {
      'Accept-Language': this.language,
      AppLang: this.language,
      LocalDateTime: currentTimezoneDateTime(),
      RefUtcTime: new Date(new Date().getTime()).toISOString(),
      'Access-Control-Allow-Origin': '*',
      LocalIanaTimezone: ianaTimezone,
    } as any;

    let accessToken = this._authorizeService.accessToken;
    if (isNotEmpty(accessToken) && this._authorizeService.isAuthenticated$ && this._authorizeService.hasValidToken()) {
      headers.Authorization = `Bearer ${encodeURIComponent(accessToken)}`;
    }

    Object.keys(headers).forEach(header => {
      if (!req.headers.get(header)) {
        req = req.clone({
          headers: req.headers.append(header, headers[header]!),
        });
      }
    });

    return next.handle(req);
  }

  private get language(): string {
    return localStorage.getItem('selectedLanguage') ?? navigator.language;
  }
}
